import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BatchService } from '@lead-hunter/data-access';

@Component({
  selector: 'lead-warning-extraction',
  templateUrl: './warning-extraction.component.html',
  styleUrls: ['./warning-extraction.component.scss']
})
export class WarningExtractionComponent implements OnInit {

  public id: string;

  //TODO: Remover esse mock
  public time: string = '09h 30min';

  constructor(private batchService: BatchService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  downloadGeneratedFile() {
    this.batchService
      .downloadFile(this.id)
      .toPromise()
      .then((response: any) => {
        const file: Blob = response.body as Blob;
        const a = document.createElement('a');
        a.download = this.id;
        a.href = window.URL.createObjectURL(file);
        a.click();
        this.dialog.closeAll();
      });

  }

}
